<template>
    <div>
        <div class="row mt-2 align-items-center">
            <div class="col-12 col-sm-7">
                <h6 class="font-weight-bold no-wrap mb-0">Select a design</h6>
            </div>
            <div class="col-12 col-sm-5">
                <modal-import-search @search-text-change="updateSearchText" />
            </div>
        </div>
        <modal-import-list class="mt-2 mb-4" :items="items" :is-loading="isLoading" @item-selected="itemSelected" />
        <b-pagination
            v-model="currentPage"
            :total-rows="totalDesigns"
            :per-page="perPage"
            aria-controls="my-table"
            align="center"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import ModalImportSearch from '../../search/ModalImportSearch.vue';
import ModalImportList from '../../list/ModalImportList.vue';
import { Item } from '@/components/Layers/modal/types';

const emit = defineEmits<{
    (event: 'design-selected'): void;
}>();

const perPage = 5;
const isLoading = ref(true);
const currentPage = ref(1);
const searchText = ref('');

const designs = computed(() => store.state.storeLayersModal!.designs);
const totalDesigns = computed(() => store.state.storeLayersModal!.totalDesigns);

const items = computed(() => {
    return designs.value.map((design) => ({
        thumb: design.images[0],
        name: design.title,
        id: design.id
    }));
});

watch(currentPage, () => {
    fetchDesigns();
});

onMounted(async () => {
    await fetchDesigns();
});

const updateSearchText = async (value: string) => {
    searchText.value = value;
    await fetchDesigns();
};

const fetchDesigns = async () => {
    try {
        isLoading.value = true;
        await store.dispatch('storeLayersModal/getDesigns', {
            from: (currentPage.value - 1) * perPage,
            count: perPage,
            search: searchText.value,
            byAdmin: false
        });
    } finally {
        isLoading.value = false;
    }
};

const itemSelected = async (item: Item) => {
    try {
        isLoading.value = true;
        const design = designs.value.find((design) => design.id === item.id);
        if (design) {
            await store.dispatch('storeLayersModal/getDesign', design.id);
            store.dispatch('storeLayersModal/setSelectedItem', item);
            emit('design-selected');
        }
    } finally {
        isLoading.value = false;
    }
};
</script>
